import FeederAndScreenST from './FeederAndScreenST.png';
import FeederAndScreenST2 from './FeederAndScreenST_2.png';

export const getImageFeederAndScreen = () => {
  return FeederAndScreenST;
};

export const getImageFeederAndScreen2 = () => {
  return FeederAndScreenST2;
};
